import { render, staticRenderFns } from "./GoodsDeclaration.vue?vue&type=template&id=6d5153fe"
import script from "./GoodsDeclaration.vue?vue&type=script&lang=js"
export * from "./GoodsDeclaration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports